
const Heading = () => {
    return (
        <section className="py-3">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-12">
                        <h1 className='font-bold text-black text-uppercase pb-5 text-uppercase'>Let's build your <br /> brand future</h1>
                        <p>Have a project in mind? Need to name something bold and new? We're listening.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Heading;